/**
 * Business intelligence signal for search results
 */
export enum BiSignal {
  BI_SIGNAL_UNKNOWN = 'BI_SIGNAL_UNKNOWN',
  TRENDING = 'TRENDING',
  POPULAR_WITH_YOUR_STORE = 'POPULAR_WITH_YOUR_STORE',
  NOT_IN_YOUR_AREA = 'NOT_IN_YOUR_AREA',
  FAST_SHIPPING = 'FAST_SHIPPING',
}
